import { api } from './api';

export const useAPI = () => api;
